module.exports = __webpack_public_path__ + "img/cw.8144e2c1.svg";